import styled from 'styled-components';
import { ProgressStepperStepLabelTextMixin } from '../../mixins/components/ProgressStepperStepLabelTextMixin';
export var StyledProgressStepperStepLabelText = /*#__PURE__*/styled.span.withConfig({
  displayName: "StyledProgressStepperStepLabelText",
  componentId: "c11n-8-111-1__sc-10vfukr-0"
})(["", ""], ProgressStepperStepLabelTextMixin);